import React from 'react';
import { useIntl } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import image from './bg.jpg';

const useStyles = makeStyles(theme => ({
  paper: {
    maxWidth: '600px',
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  title: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  card: {
    width: '100%',
    maxWidth: 600
  },
  media: {
    height: 150
  },
  version: {
    color: theme.palette.grey[500]
  },
  content: {
    marginTop: theme.spacing(2)
  },
  container: {
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

function Splash({ actions, content }) {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <CardMedia
          className={classes.media}
          image={image}
          title={formatMessage({ id: 'splash.imageTitle' })}
        />
        <CardContent>
          <Typography variant="h6">iFoodPPSI</Typography>
          <Typography
            variant="caption"
            gutterBottom
            className={classes.version}
          >
            <code>{process.env.REACT_APP_VERSION || 'N/A'}</code>
          </Typography>
          <div className={classes.content}>{content}</div>
        </CardContent>
        {actions && <CardActions>{actions}</CardActions>}
      </Card>
    </div>
  );
}

export default Splash;
